if (!customElements.get('faq-menu-dropdown')) {
  customElements.define(
    'faq-menu-dropdown',
    class FaqMenuDropdown extends HTMLElement {
      constructor() {
        super();
        this.isOpen = false;
        this.addEventListener('click', (event) => {
          this.toggleMenu(event);
        });
      }

      toggleMenu(event) {
        if (!this.isOpen) {
          this.expandMenu();
        } else {
          this.collapseMenu();
        }
      }

      expandMenu() {
        trapFocus(this);
        this.classList.add('open-menu');
        this.setAttribute('aria-expanded', 'true');
        this.isOpen = true;
      }

      collapseMenu() {
        this.classList.remove('open-menu');
        this.setAttribute('aria-expanded', 'false');
        this.isOpen = false;
      }
    }
  );
}